import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);
import menuRouters from '../router/menu-router';
import createPersistedState from "vuex-persistedstate"

export default new Vuex.Store({
	plugins: [createPersistedState()],// 缓存state
	state: {
		token: '',//token
		menuList: [],// 菜单列表
		menuCollapse:false,
		curMenuRouter: '',// 当前选中一级菜单
		curMenuOpened: [],// 当前展开二级菜单
		editId: '',// 编辑的对象ID
		userType: '', //编辑的对象类型
		breadCrumbList: [],// 面包屑配置列表
		supplierCheckInfo:{},// 审核服务商跳转时传值
		userInfo:{},//当前用户信息
		corpNo:'',//公司编号
		curUserMenuList:[],// 当前用户菜单列表
		curUserAuthList:[],// 当前用户菜单列表
		financeManageDealer:{},//入账审核/财务审核 页面使用到的运营商数据
		stationObj:{},//电站管理 资费 使用的
		repairObj:{},//电站管理，维修需要使用

		searchList: {}, // 结算总表详表 - 查询条件
		searchParams: {}, // 清分擦汗寻详情所需字段

		receiveOrder: {}, // 清分订单详情数据
	},
	mutations: {
		setCurUserMenuList(state, curUserMenuList) {
			state.curUserMenuList = curUserMenuList;
		},
		setCurUserAuthList(state, curUserAuthList) {
			state.curUserAuthList = curUserAuthList;
		},
		updateMenuList(state, menuList) {
			state.menuList = menuRouters;
		},
		// 设置token
		setToken(state, token) {
			state.token = token;
		},
		setCorpNo(state, corpNo) {
			state.corpNo = corpNo;
		},
		setUserInfo(state, userInfo) {
			state.userInfo = userInfo;
		},
		// 设置当前的选中的页面菜单
		setCurMenuRouter(state, curMenuRouter) {
			state.curMenuRouter = curMenuRouter;
		},
		// 设置当前的展开的页面菜单
		setCurMenuOpened(state, curMenuOpened) {
			state.curMenuOpened = curMenuOpened;
		},
		// 设置菜单的展开收起
		setMenuCollapse(state, menuCollapse) {
			state.menuCollapse = menuCollapse;
		},
		// 编辑的对象ID
		setEditId(state, editId) {
			state.editId = editId;
		},
		setStationNo(state, stationNo) {
			state.stationNo = stationNo;
		},
		//充电桩编号
		setPileNo(state, pileNo) {
			state.pileNo = pileNo;
		},
		// 编辑的对象类型
		setUserType(state, userType) {
            state.userType = userType;
		},
		setBreadCrumbList(state, breadCrumbList){
			state.breadCrumbList = breadCrumbList;
		},
		setSupplierCheckInfo(state, supplierCheckInfo){
			state.supplierCheckInfo = supplierCheckInfo;
		},
		setFinanceManageDealer(state, financeManageDealer){
			state.financeManageDealer = financeManageDealer;
		},
		setStationObj(state, stationObj){
			state.stationObj = stationObj;
		},
		setRepairObj(state, repairObj){
			state.repairObj = repairObj;
		},
		setSearchList(state, searchList) {
			state.searchList = searchList;
		},
		setSearchParams(state, searchParams) {
			state.searchParams = searchParams;
		},
		setReceiveOrder(state, receiveOrder) {
			state.receiveOrder = receiveOrder;
		},
	},
	actions: {
	},
	modules: {
	}
})
